import API from "services/axios";

/**
 * Shared by the Product Information cards (SProductInformation: Default;
 * ProductLocationOverrides: per location). Kept apart so neither imports the
 * other.
 */

export const INFORMATION_PDFS = [
  {
    field: "productImagePdf",
    label: "Pdf Of Product Images",
    hint: "The product sheet or photo, as a PDF.",
  },
  {
    field: "productSizeChartPdf",
    label: "Pdf of Product Size Chart",
    hint: "The size chart, as a PDF.",
  },
];

// Stored keys are `<folder>/<filename>`; only the filename is worth showing.
export const fileNameOf = (key) =>
  String(key || "")
    .split("/")
    .filter(Boolean)
    .pop() || "";

// A url typed without a scheme ("acme.com/st420") is not a link a browser will
// follow as-is -- it would resolve against this app's own origin.
export const toHref = (url) => {
  const value = String(url || "").trim();
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};

// Opens a stored PDF in a new tab -- inline + the type, see
// ProductInformationButtons for why the type has to be stated.
export const openStoredPdf = async (key) => {
  const { data } = await API.post("/aws/images", {
    key,
    inline: true,
    contentType: "application/pdf",
  });
  const url = Array.isArray(data) ? data[0] : data;
  if (!url) throw new Error("No link came back for that file.");
  window.open(url, "_blank", "noopener,noreferrer");
};
